/* eslint-disable @typescript-eslint/camelcase */
import { StringMap } from '../common/interfaces/stringMap';

export const supportUrls: StringMap = {
  en_us: 'en_US',
  da_dk: 'da',
  de_de: 'de',
  fr_fr: 'fr',
  it_it: 'it',
  nl_nl: 'nl_NL',
  no_no: 'no',
  fi_fi: 'fi',
  sv_se: 'sv',
  zh_cn: 'zh_CN',
};
